import React from 'react';

const clampVisualLevel = (value) => {
  const level = Number(value);
  if (!Number.isFinite(level)) return 0;
  return Math.max(0, Math.min(1, level));
};

export default function RadioMusicVisual({
  as: Component = 'div',
  isPlaying = false,
  barCount = 5,
  className = '',
  variant = 'dock',
  levels = [],
  intensity = 0,
  isBeatReactive = false,
  style = null,
}) {
  const safeBarCount = Math.max(1, Math.min(8, Number(barCount) || 5));
  const safeLevels = Array.isArray(levels)
    ? levels.slice(0, safeBarCount).map(clampVisualLevel)
    : [];
  const hasReactiveLevels = isPlaying && isBeatReactive && safeLevels.length > 0;
  const safeIntensity = clampVisualLevel(intensity);
  const classNames = [
    'radio-music-visual',
    `radio-music-visual--${variant}`,
    className,
    isPlaying ? 'is-playing' : '',
    hasReactiveLevels ? 'is-audio-reactive' : '',
  ]
    .filter(Boolean)
    .join(' ');
  const visualStyle = {
    ...(style || {}),
    '--radio-audio-intensity': safeIntensity.toFixed(3),
  };

  return (
    <Component className={classNames} aria-hidden="true" style={visualStyle}>
      {Array.from({ length: safeBarCount }, (_, index) => (
        <span
          key={index}
          style={
            hasReactiveLevels
              ? {
                  '--radio-bar-level': (safeLevels[index] || 0).toFixed(3),
                  '--radio-bar-scale': (
                    0.22 +
                    (safeLevels[index] || 0) * 0.78
                  ).toFixed(3),
                  '--radio-bar-opacity': (
                    0.52 +
                    (safeLevels[index] || 0) * 0.48
                  ).toFixed(3),
                  '--radio-bar-glow': `${Math.round(
                    5 + (safeLevels[index] || 0) * 16,
                  )}px`,
                }
              : undefined
          }
        />
      ))}
    </Component>
  );
}
